module.exports = __webpack_public_path__ + "img/logo-kop-simtaru.b41e4131.png";